<app-base-list [listTitle]="'HOME.PERFORMANCE_TABLE.TITLE' | transloco">
  <ng-container *ngIf="!busy; else loadingState">
    <ng-container *ngIf="performanceTable; else emptyState">
      <app-item-list
        *ngFor="let performance of this.performanceTable"
        [subtitle]="'HOME.PERFORMANCE_TABLE.ENUM.TITLE.' + performance.attributes.periodType | transloco"
        [title]="'HOME.PERFORMANCE_TABLE.ENUM.SUBTITLE.' + performance.attributes.periodType | transloco"
        [iconText]="'HOME.PERFORMANCE_TABLE.ENUM.ICON.' + performance.attributes.periodType | transloco"
        [iconTextColor]="iconTextColor"
        [iconTextFontSize]="'20px'"
        [note]="performance.attributes.performanceValue || 0 | percent : '1.0-2' : 'fr'"
        [noteColor]="colorPerformance"
      />
    </ng-container>
  </ng-container>
  <ng-template #loadingState>
    <app-item-list [busy]="busy" *ngFor="let _ of [].constructor(5)" />
  </ng-template>
  <ng-template #emptyState>
    <ion-item color="light" class="text-center">
      <ion-label class="p-8">{{ "WALLET.DETAILS.EMPTY" | transloco }}</ion-label>
    </ion-item>
  </ng-template>
</app-base-list>